module.exports = __webpack_public_path__ + "static/decima-mono-367094d4762fbcc73ec33f163df29c49.otf";